import { COLOR_ABS, LINE_DASHARRAY } from './constants'

interface ISvgLineProps {
  color: string
  x1: number
  y1: number
  x2: number
  y2: number
}

const SvgLine: React.FC<ISvgLineProps> = ({ x1, x2, y1, y2, color = COLOR_ABS }) => {
  return <line stroke={color} strokeDasharray={LINE_DASHARRAY} x1={x1} x2={x2} y1={y1} y2={y2} />
}

export default SvgLine
